<script lang="ts">
	import Media from "@components/common/Media.svelte";
	import type { ContentType } from "@core/schema/ContentType.js";
	import type { ContentBlockComponentProps } from "./ContentBlockComponentProps.js";
	import MediaTextBlockLayout from "./MediaTextBlockLayout.svelte";

	const { data, lightboxId }: ContentBlockComponentProps<ContentType.VideoText> = $props();
</script>

<MediaTextBlockLayout
	html={data.html}
	reversed={data.reversed}
	{lightboxId}
	mediaClass="aspect-video h-auto w-full flex-1"
>
	{#snippet media()}
		<Media
			source={{ youtube: data.youtubeUrl }}
			sourcesets={{}}
			alt=""
			width={800}
			height={800}
			lightbox={lightboxId ?? true}
			lightboxClass="!absolute inset-0 size-full"
			class="size-full object-cover"
			wrapperClass="absolute inset-0"
		/>
	{/snippet}
</MediaTextBlockLayout>
